import { render, staticRenderFns } from "./BannerHighlightForm.vue?vue&type=template&id=78cfcff6&scoped=true&"
import script from "./BannerHighlightForm.vue?vue&type=script&lang=js&"
export * from "./BannerHighlightForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerHighlightForm.vue?vue&type=style&index=0&id=78cfcff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cfcff6",
  null
  
)

export default component.exports